export interface SponsorInfo {
  id: string;
  name: string;
}

export interface Sponsor {
  id: string;
  name: string;
  logoId: string;
}

export interface ModifySponsorRequest {
  name: string;
  logoId: string;
}

export function defaultSponsor(): Sponsor {
  return {
    id: null,
    name: null,
    logoId: null,
  };
}

export function toRequest(sponsor: Sponsor): ModifySponsorRequest {
  return {
    name: sponsor.name,
    logoId: sponsor.logoId,
  };
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/sponsors/sponsors.interfaces.ts